import styled from '@emotion/styled';
import CalendarComponent from 'react-calendar';

export const Calendar = styled(CalendarComponent)`
  font-family: ${(props) => props.theme.font.default} !important;
  color: ${(props) => props.theme.color.dark.shade} !important;
  border: none !important;
  width: 100% !important;
  padding-bottom: 10px;

  .react-calendar__navigation__label {
    font-family: ${(props) => props.theme.font.default} !important;
    color: ${(props) => props.theme.color.dark.shade} !important;
    font-weight: 600;
    font-size: 14px;
  }

  .react-calendar__tile {
    font-family: ${(props) => props.theme.font.default} !important;
    color: ${(props) => props.theme.color.dark.default} !important;
    padding: 5px;
    font-weight: 500;
    font-size: 13px;
  }

  .react-calendar__month-view__weekdays {
    font-family: ${(props) => props.theme.font.default} !important;
    color: ${(props) => props.theme.color.dark.shade} !important;
    font-weight: 600;
    font-size: 10px;
    .react-calendar__month-view__weekdays__weekday > [title] {
      text-decoration: none !important;
    }
  }

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now {
    border: 1px solid ${(props) => props.theme.color.blue.default};
    background: transparent;
    font-weight: 700;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active,
  .react-calendar__tile--hasActive {
    background: ${(props) => props.theme.color.blue.default} !important;
    color: ${(props) => props.theme.color.light.default} !important;
    font-weight: 700;
  }

  .react-calendar__navigation {
    margin-bottom: 0px;
  }

  .react-calendar__navigation__arrow.react-calendar__navigation__next2-button {
    display: none !important;
  }
  .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button {
    display: none !important;
  }
`;
